import React from "react";
import RippleButton from "./RippleButton";

export const ArrowButton = ({
  className,
  isLeft = true,
  disabled = false,
  onClick = () => {},
}) => {
  return (
    <RippleButton className={className} disabled={disabled} onClick={onClick}>
      <svg
        focusable="false"
        color="gray"
        aria-hidden="true"
        viewBox="0 0 24 24"
        className={`transform ${isLeft ? "rotate-0" : "rotate-180"}`}
      >
        <path d="M14.71 6.71a.9959.9959 0 0 0-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41"></path>
      </svg>
    </RippleButton>
  );
};
